import { createSelector } from 'reselect';
import time from 'yoda-core-components/lib/moment/Time';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import { COOKIE_PREVIEW_DATE } from '../common/Constants';
import { isPreview } from './ContextSelector';
import DateFormatter from '../dates/DateFormatter/DateFormatter';

const getPreviewDate = createSelector([isPreview], (isPreviewPage) => {
    let formattedPreviewDate = null;
    /* istanbul ignore next */
    if (isPreviewPage) {
        let previewDate = Cookies.load(COOKIE_PREVIEW_DATE);
        if (previewDate) {
            previewDate = previewDate.includes('.')
                ? time(
                      `${time(previewDate, 'YYYY.MM.DD HH:mm A').format(
                          'YYYY-MM-DDTHH:mm'
                      )}:00.000-06:00`
                  )
                : new Date(previewDate);

            if (!isNaN(previewDate) && !previewDate.format) {
                formattedPreviewDate = DateFormatter.formatWithOptions(previewDate, '-');
            } else {
                formattedPreviewDate = previewDate;
            }
        }
        return formattedPreviewDate || time(new Date());
    }
    return formattedPreviewDate;
});

export default getPreviewDate;
